import { withStyles } from '@material-ui/styles';
import HubLockUserCodesForm from './HubLockUserCodesForm';
import styles from './styles';

export default withStyles(styles)(HubLockUserCodesForm);
